import { TimeServiceOutput } from './TimeServiceOutput';
export class TimeService {
    static instance;
    output;
    intervalId;
    async init() {
        // No initialization needed
    }
    static getInstance() {
        if (!TimeService.instance) {
            TimeService.instance = new TimeService();
        }
        return TimeService.instance;
    }
    static getNotificationInterface() {
        return TimeService.getInstance();
    }
    static getOutput() {
        return TimeServiceOutput.getReactiveOutput();
    }
    // ------------- Singleton implementation end
    constructor() {
        this.output = new TimeServiceOutput();
    }
    notifyStart() {
        this.output.setTime(Date.now());
        this.intervalId = window.setInterval(() => {
            this.output.setTime(Date.now());
        }, 1000);
    }
    notifyStop() {
        if (this.intervalId) {
            window.clearInterval(this.intervalId);
            this.intervalId = undefined;
        }
    }
}
